import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, ViewRef, inject } from '@angular/core';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs';
import { SagepayCloudPaymentService } from './sagepay-cloud-payment.service';

@Directive()
export abstract class SagepayCloudPaymentCurrentNameComponentDef implements OnInit, OnDestroy {
    @Input()
    charsToDisplay?: number;

    name?: string;

    status = new Status();

    protected subscriptions = new Subscription();

    protected sagepayCloudPayment = inject(SagepayCloudPaymentService);
    protected app = inject(App);
    protected changeDetectorRef = inject(ChangeDetectorRef);
    private timeoutService = inject(TimeoutService);

    ngOnInit() {
        this.subscriptions.add(this.sagepayCloudPayment.storeIdSubject.subscribe((storeId: number | null) => this.onStoreChange(storeId)));
        this.onStoreChange(this.sagepayCloudPayment.storeId);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    protected onStoreChange(id: number | null): void {
        if (id) {
            const setName = () => {
                this.setName(id);
            };
            this.app.request.send(this.status, () => this.app.resources.store.load(id, 1), setName, setName);
        } else {
            this.setName(undefined);
        }
    }

    protected setName(storeId?: number): void {
        const store = this.app.resources.store.getExisting(storeId);
        
        if (store?.data?.store_name) {
            this.name = store.data.store_name.substring(0, this.charsToDisplay).trim();
        } else {
            this.name = undefined;
        }

        this.detectChanges();
    }

    protected detectChanges(): void {
        this.timeoutService.async(() => {
            if (!(<ViewRef>this.changeDetectorRef).destroyed) {
                this.changeDetectorRef.detectChanges();
            }
        });
    }
}